/** @public @react */
export const DefaultSvgDefs = () => {
	return null
}
